const scrollTo = function(e) {
    let offset = parseInt(e.currentTarget.dataset.scrollOffset) || 0 ;
    if (e.currentTarget.href) {
        e.preventDefault();
        let el = '#' + e.currentTarget.href.split('#')[1];
       smoothScroll.animateScroll( document.querySelector(el) , null, {offset: offset});
    } else {
       smoothScroll.animateScroll( offset );
    }
    // console.log(smoothScroll)
}

export default scrollTo;


// WEBPACK FOOTER //
// ./src/helpers/SmoothScroll.js